import { render, staticRenderFns } from "./TrademarkApplicationTypeForm.vue?vue&type=template&id=3ceb8110&"
import script from "./TrademarkApplicationTypeForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkApplicationTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkApplicationTypeForm.vue?vue&type=style&index=0&id=3ceb8110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports